import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=75957183&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75957183')) {
      api.createRecord('75957183', component.options)
    } else {
      api.reload('75957183', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=75957183&", function () {
      api.rerender('75957183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/offershelp.vue"
export default component.exports